import { render, staticRenderFns } from "./Otherdocuments.vue?vue&type=template&id=7a44a68a&scoped=true&"
import script from "./Otherdocuments.vue?vue&type=script&lang=js&"
export * from "./Otherdocuments.vue?vue&type=script&lang=js&"
import style0 from "./Otherdocuments.vue?vue&type=style&index=0&id=7a44a68a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a44a68a",
  null
  
)

export default component.exports